import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import {
  useAccount
} from 'wagmi';

const Nav = () => {

    const { isConnected } = useAccount();

    const [navbarOpen, setNavbarOpen] = useState(false)

    const handleToggle = () => {
        setNavbarOpen(prev => !prev)
    }
    
  return (
    <>
            {isConnected && (
            
                <div className="navigation center">
                    <Link className="button" to="/">Home</Link>
                    <Link className="button" to="/token">Token</Link>
                    <Link className="button" to="/mint">Mint</Link>
                    <Link className="button" to="/swap">Swap</Link>
                    <Link className="button" to="/about">About</Link>
                </div>
            )}
            
                <div className="navigation center">
                    <Link className="button" to="/">Home</Link>
                    <Link className="button" to="/token">Token</Link>
                    <Link className="button" to="/mint">Mint</Link>
                    <Link className="button" to="/swap">Swap</Link>
                    <Link className="button" to="/about">About</Link>
                </div>
            
    </>
  )
};

export default Nav